//# sourceMappingURL=data_sources.mjs.map
/// <reference types="./data_sources.d.mts" />
import * as $data_source from "../../data_types/data/data_source.mjs";
import * as $remote from "../../data_types/data/remote.mjs";
import * as $dict from "../../gleam_stdlib/gleam/dict.mjs";
import * as $decode from "../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $result from "../../gleam_stdlib/gleam/result.mjs";
import * as $storage from "../../magellan/magellan/storage.mjs";
import { toList, CustomType as $CustomType } from "../gleam.mjs";

export class DataSources extends $CustomType {
  constructor(viewed, paginated, sources) {
    super();
    this.viewed = viewed;
    this.paginated = paginated;
    this.sources = sources;
  }
}
export const DataSources$DataSources = (viewed, paginated, sources) =>
  new DataSources(viewed, paginated, sources);
export const DataSources$isDataSources = (value) =>
  value instanceof DataSources;
export const DataSources$DataSources$viewed = (value) => value.viewed;
export const DataSources$DataSources$0 = (value) => value.viewed;
export const DataSources$DataSources$paginated = (value) => value.paginated;
export const DataSources$DataSources$1 = (value) => value.paginated;
export const DataSources$DataSources$sources = (value) => value.sources;
export const DataSources$DataSources$2 = (value) => value.sources;

function read_local_storage() {
  let _pipe = $storage.get_json(new $storage.Local(), "data-sources-viewed");
  let _pipe$1 = $result.replace_error(_pipe, toList([]));
  let _pipe$2 = $result.try$(
    _pipe$1,
    (_capture) => {
      return $decode.run(_capture, $decode.dict($decode.string, $decode.int));
    },
  );
  return $result.unwrap(_pipe$2, $dict.new$());
}

/**
 * Should only be used once per lifecycle, because it relies on side-effect.
 * Side-effects should normally be properly handled in effectful code, not in
 * any function like that. Refactor this later, when structure is better for
 * data sources viewer.
 */
export function new$() {
  let viewed = read_local_storage();
  return new DataSources(viewed, $dict.new$(), $dict.new$());
}

export function total(data_sources, organization, total) {
  return new DataSources(
    data_sources.viewed,
    $dict.insert(data_sources.paginated, organization, total),
    data_sources.sources,
  );
}

export function errored(data_sources, organization, page, error) {
  return new DataSources(
    data_sources.viewed,
    data_sources.paginated,
    $dict.insert(
      data_sources.sources,
      organization,
      (() => {
        let _pipe = $dict.get(data_sources.sources, organization);
        let _pipe$1 = $result.lazy_unwrap(_pipe, $dict.new$);
        return $dict.insert(_pipe$1, page, new $remote.Errored(error));
      })(),
    ),
  );
}

export function loading(data_sources, organization, page) {
  return new DataSources(
    data_sources.viewed,
    data_sources.paginated,
    $dict.insert(
      data_sources.sources,
      organization,
      (() => {
        let _pipe = $dict.get(data_sources.sources, organization);
        let _pipe$1 = $result.lazy_unwrap(_pipe, $dict.new$);
        return $dict.insert(_pipe$1, page, new $remote.Loading());
      })(),
    ),
  );
}

export function loaded(data_sources, organization, page, sources) {
  return new DataSources(
    data_sources.viewed,
    data_sources.paginated,
    $dict.insert(
      data_sources.sources,
      organization,
      (() => {
        let _pipe = $dict.get(data_sources.sources, organization);
        let _pipe$1 = $result.lazy_unwrap(_pipe, $dict.new$);
        return $dict.insert(_pipe$1, page, new $remote.Loaded(sources));
      })(),
    ),
  );
}

export function get(data_sources, organization, page) {
  let _pipe = data_sources.sources;
  let _pipe$1 = $dict.get(_pipe, organization);
  return $result.try$(
    _pipe$1,
    (_capture) => { return $dict.get(_capture, page); },
  );
}

export function set_sources(data_sources, sources) {
  return new DataSources(data_sources.viewed, data_sources.paginated, sources);
}
